import React from 'react';
import Head from 'next/head';

import { makeScript, preConnect } from '../script';

interface TatariTrackObject {
  track: Function;
  identify: Function;
}

export interface TatariPixelScriptProps {
  pixelID?: string;
}

/**
 * Script function.
 *
 * @param ctx
 */
function ttr(ctx: TatariPixelScriptProps) {
  /*eslint-disable */
  // prettier-ignore

  if (ctx.pixelID) {
    // @ts-ignore
    !function(){try{!function(t,i){if(!i.version){window.tatari=i,i.init=function(t,n){var e=function(t,n){i[n]=function(){t.push([n].concat(Array.prototype.slice.call(arguments,0)))}};"track pageview identify".split(" ").forEach(function(t){e(i,t)}),i._i=t,i.config=n,i.pageview()},i.version="1.2.1";var n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://d2hrivdxn8ekm8.cloudfront.net/tag-manager/ee1e8fdf-41a0-4210-8eb0-10a315ae410c-latest.js";var e=t.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)}}(document,window.tatari||[])}catch(t){console.log(t)}}(); tatari.init(ctx.pixelID);
  }
}

export const TatariPixelScript = (props: TatariPixelScriptProps): JSX.Element => {
  const pixelID = props.pixelID || process.env.NEXT_PUBLIC_TATARI_PIXEL_ID;
  return <Head>{pixelID && makeScript(ttr, { pixelID })}</Head>;
};

export default TatariPixelScript;
